$("header-drawer").click(function () {
    console.log("click!");
    $(this).toggleClass('active');
    $(".header__heading").toggleClass('active');
});

$(window).scroll(function () {
    if ($(window).scrollTop() > 716) {
        $('.header__icon').addClass('black');
        $('.sp-cart-wrap a .pc').addClass('active');
        $('.sp-cart-wrap a .sp').addClass('hidden');
    } else {
        $('.header__icon').removeClass('black');
        $('.sp-cart-wrap a .pc').removeClass('active');
        $('.sp-cart-wrap a .sp').removeClass('hidden');
    }
});